var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-popup monitor-graph",
      style: _vm.css_props,
      attrs: { id: "monitor_buoy" }
    },
    [
      Object.keys(_vm.timeseries_data).length !== 0
        ? _c("v-card", { staticClass: "base-popup__wrapper" }, [
            _c(
              "div",
              {
                staticClass: "base-popup__container",
                attrs: { id: "base-popup__capture_range" }
              },
              [
                _c("div", { staticClass: "base-popup__tooltip" }, [
                  _c("div", { staticClass: "base-popup__tooltip-title" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass: "base-popup__tooltip-title__city_info"
                          },
                          [_c("h1", [_vm._v(_vm._s(_vm.station_title))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "base-popup__tooltip-close-btn",
                            attrs: { color: "white", icon: "" },
                            on: { click: _vm.close_dialog }
                          },
                          [
                            _c("v-icon", { attrs: { color: "white" } }, [
                              _vm._v("icon-close")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "base-popup__tooltip-selection" }, [
                    _c(
                      "div",
                      { staticClass: "selection-input" },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.variable_select,
                            id: "tsgraph-select-type",
                            "item-text": "text",
                            "item-value": "value",
                            label: _vm.$t("__monitor_weather.weather_variable")
                          },
                          model: {
                            value: _vm.variable_selected,
                            callback: function($$v) {
                              _vm.variable_selected = $$v
                            },
                            expression: "variable_selected"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.variable_selected === _vm.$t("__rainfall.rainfall")
                      ? _c(
                          "div",
                          { staticClass: "selection-input" },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.rain_select,
                                id: "tsgraph-select-type",
                                "item-text": "text",
                                "item-value": "value",
                                label: _vm.$t("__timeseries.time_select_text")
                              },
                              model: {
                                value: _vm.rain_selected,
                                callback: function($$v) {
                                  _vm.rain_selected = $$v
                                },
                                expression: "rain_selected"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "selection-input" },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.day_select,
                            id: "tsgraph-select-day",
                            "item-text": "text",
                            "item-value": "value",
                            label: _vm.$t("__chart_common.day_select_text")
                          },
                          model: {
                            value: _vm.day_selected,
                            callback: function($$v) {
                              _vm.day_selected = $$v
                            },
                            expression: "day_selected"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "base-popup__content" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "base-popup__content-detail d-flex justify-space-between"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.is_pad_width
                                  ? _vm.props_svg_sub_title.time
                                  : _vm.props_svg_sub_title.full_title
                              ) +
                              "\n                            "
                          ),
                          !_vm.is_mobile_width
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { id: "tsgraph-reset-btn", icon: "" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "black" },
                                      on: { click: _vm.reset_time_range }
                                    },
                                    [_vm._v("icon-autorenew")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.is_mobile_width
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { id: "tsgraph-download", icon: "" },
                                  on: { click: _vm.save_png }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v("icon-file-download")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "close-btn",
                                  attrs: { color: "black", icon: "" },
                                  on: { click: _vm.close_dialog }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v("mdi-close")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.is_mobile_width
                        ? _c(
                            "v-menu",
                            {
                              attrs: { "offset-y": "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  color: "black",
                                                  dark: "",
                                                  icon: ""
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("icon-more")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2842754205
                              )
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    { on: { click: _vm.reset_time_range } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "black" } },
                                        [_vm._v("icon-autorenew")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "__chart_common.reset_time_range"
                                            )
                                          ) +
                                          "\n                                "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item",
                                    { on: { click: _vm.save_png } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "black" } },
                                        [_vm._v("icon-file-download")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t("__chart_common.save_image")
                                          ) +
                                          "\n                                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.should_draw_histogram_diagram_header.includes(
                    _vm.variable_selected
                  )
                    ? _c("div", { staticClass: "base-popup__content-legend" }, [
                        _c("span", { staticClass: "legend histogram" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.variable_selected) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "legend no-data-label" }, [
                          _vm._v("✚")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("__chart_common.legend_no_data")) +
                            "\n                    "
                        )
                      ])
                    : _vm.should_draw_line_diagram_header.includes(
                        _vm.variable_selected
                      )
                      ? _c(
                          "div",
                          { staticClass: "base-popup__content-legend" },
                          [
                            _c("span", {
                              staticClass: "legend",
                              class: {
                                line: _vm.variable_selected !== "風向",
                                circle: _vm.variable_selected === "風向"
                              }
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.variable_selected) +
                                "\n                        "
                            ),
                            _c(
                              "span",
                              { staticClass: "legend no-data-label" },
                              [_vm._v("✚")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("__chart_common.legend_no_data")
                                ) +
                                "\n                        "
                            ),
                            _vm.need_extreme_value_headers.includes(
                              _vm.variable_selected
                            )
                              ? [
                                  _c("span", {
                                    staticClass: "legend triangle__wind-max"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "" +
                                          _vm.$t(
                                            "__monitor_weather.legend_max"
                                          ) +
                                          _vm.variable_selected
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("span", {
                                    staticClass: "legend triangle__wind-min"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "" +
                                          _vm.$t(
                                            "__monitor_weather.legend_min"
                                          ) +
                                          _vm.variable_selected
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.variable_selected ===
                            _vm.$t("__monitor_weather.wind_speed")
                              ? [
                                  _c("span", {
                                    staticClass: "legend triangle__gust-max"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "" +
                                          _vm.$t(
                                            "__monitor_weather.legend_max"
                                          ) +
                                          _vm.$t(
                                            "__monitor_weather.legend_gust"
                                          )
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("span", { staticClass: "legend cross" }, [
                                    _vm._v("✚")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("__monitor_weather.legend_gust")
                                      ) +
                                      "\n                            "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "legend gust_time" },
                                    [_vm._v("HH:MM")]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      "" +
                                        _vm.$t(
                                          "__monitor_weather.legend_gust"
                                        ) +
                                        _vm.$t(
                                          "__monitor_weather.legend_time_text"
                                        )
                                    ) + "\n                        "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-popup__content-graph" },
                    [
                      _vm.should_draw_histogram_diagram_header.includes(
                        _vm.variable_selected
                      )
                        ? _c("QpeHistogram", {
                            ref: "chart",
                            attrs: {
                              choosed_time_series_data:
                                _vm.choosed_time_series_data,
                              x_axis_time_series_data:
                                _vm.x_axis_time_series_data,
                              svg_main_title: _vm.station_name,
                              svg_sub_title: _vm.props_svg_sub_title.full_title,
                              basic_layout_setting: _vm.basic_layout_setting,
                              x_axis: _vm.x_axis,
                              y_axis: _vm.y_axis,
                              draw_custom_function: _vm.draw_custom_function,
                              tooltip_value_text: _vm.tooltip_value_text,
                              tooltip_value_unit: _vm.tooltip_value_unit,
                              show_data_end_time: false
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.should_draw_line_diagram_header.includes(
                        _vm.variable_selected
                      )
                        ? _c("QpeLineChart", {
                            ref: "chart",
                            attrs: {
                              choosed_time_series_data:
                                _vm.choosed_time_series_data,
                              x_axis_time_series_data:
                                _vm.x_axis_time_series_data,
                              svg_main_title: _vm.station_name,
                              svg_sub_title: _vm.props_svg_sub_title.full_title,
                              basic_layout_setting: _vm.basic_layout_setting,
                              x_axis: _vm.x_axis,
                              y_axis: _vm.y_axis,
                              draw_custom_function: _vm.draw_custom_function,
                              show_path: _vm.show_path_headers.includes(
                                _vm.variable_selected
                              ),
                              show_extreme_value: _vm.need_extreme_value_headers.includes(
                                _vm.variable_selected
                              ),
                              tooltip_value_text: _vm.tooltip_value_text,
                              tooltip_value_unit: _vm.tooltip_value_unit,
                              tooltip_value_icon_name:
                                _vm.tooltip_value_icon_name,
                              show_tick_color: !_vm.no_basic_tick_color_headers.includes(
                                _vm.variable_selected
                              ),
                              show_data_end_time: false
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-slider" }, [
                    _c(
                      "div",
                      { staticClass: "time-slider__content-container" },
                      [
                        _c("span", {
                          staticClass: "time-slider__content-before",
                          on: { click: _vm.change_dragged_index_to_first }
                        }),
                        _vm._v(" "),
                        _c("v-slider", {
                          staticClass: "time-slider__content",
                          attrs: {
                            max: _vm.max_dragged_index,
                            min: _vm.min_dragged_index,
                            "tick-labels": _vm.slider_tick_labels,
                            ticks: "always",
                            "tick-size": "4"
                          },
                          model: {
                            value: _vm.dragged_index,
                            callback: function($$v) {
                              _vm.dragged_index = $$v
                            },
                            expression: "dragged_index"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "time-slider__content-after",
                          on: { click: _vm.change_dragged_index_to_last }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "time-slider__icon-container" },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "time-slider__icon",
                            on: { click: _vm.minus_dragged_index_a_unit }
                          },
                          [
                            _vm._v(
                              "\n                                icon-backward-10\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            staticClass: "time-slider__icon",
                            on: { click: _vm.plus_dragged_index_a_unit }
                          },
                          [
                            _vm._v(
                              "\n                                icon-forward-10\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        : _c(
            "v-card",
            [
              _c(
                "v-alert",
                { staticClass: "alert", attrs: { value: true, type: "error" } },
                [_vm._v("\n                暫時無法顯示歷史圖表\n            ")]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }